import React from 'react';

import '../../Assets/Imgs/MapCardBg.png'

const MapCard = () => {
    return ( 
        <section className='MapCard'>
            <div className='MapCardContent'>
                <p className='MapCardText'>explore the venues layout</p>
            </div>
        </section>
     );
}
 
export default MapCard;